import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import JBImage from 'components/essentials/JBImage';
import MobileSlider from 'components/consumer/MobileSlider/MobileSlider';
import useScreen from 'hooks/useScreen';
import useIsBrowser from 'hooks/useIsBrowser';
import NukaCarousel from 'components/external/NukaCarousel';
const CDNImageManager = props => {
  const $ = _c(7);
  if (props.src && props.src.includes("images.ctfassets.net")) {
    let t0;
    if ($[0] !== props.alt || $[1] !== props.height || $[2] !== props.src || $[3] !== props.width) {
      t0 = <img height={props.height} width={props.width} src={props.src} alt={props.alt} />;
      $[0] = props.alt;
      $[1] = props.height;
      $[2] = props.src;
      $[3] = props.width;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    return t0;
  }
  let t0;
  if ($[5] !== props) {
    t0 = <JBImage {...props} />;
    $[5] = props;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};
CDNImageManager.propTypes = {
  alt: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const SliderStandard = props => {
  const $ = _c(3);
  const containerRef = useRef(null);
  const [beforeSlider, updateBeforeSlider] = useState(0);
  const [afterSlider, updateAfterSlider] = useState(0);
  const {
    imageHeight: t0,
    imageWidth: t1
  } = props;
  let imageHeight = t0;
  let imageWidth = t1;
  const {
    children,
    finalVisibleSlides,
    hideArrowsIfAllSlidesVisible: t2,
    imageArray,
    navType,
    slideIndex,
    updateImageArraySize
  } = props;
  const hideArrowsIfAllSlidesVisible = t2 === undefined ? false : t2;
  let finalSlides = imageArray || children;
  let visibleSlides = 0;
  useEffect(() => {
    if (beforeSlider) {
      if (beforeSlider < afterSlider) {
        if (afterSlider > finalSlides.length - afterSlider) {
          if (updateImageArraySize) {
            updateImageArraySize(afterSlider);
          }
        }
      } else {
        if (beforeSlider > afterSlider) {
          if (afterSlider === finalSlides.length - visibleSlides) {
            if (updateImageArraySize) {
              updateImageArraySize(afterSlider);
            }
          }
        }
      }
    }
  }, [afterSlider, beforeSlider, finalSlides.length, updateImageArraySize, visibleSlides]);
  const isBrowser = useIsBrowser();
  const {
    isMobile
  } = useScreen();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      query: "(min-width: 1281px)"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const isLargeDesktopDevice = useMediaQuery(t3);
  const isLargeDesktop = isBrowser ? isLargeDesktopDevice : false;
  const isMobileTabletOrSmallDesktop = !isLargeDesktop;
  if (isLargeDesktop) {
    visibleSlides = finalVisibleSlides && finalVisibleSlides < 4 ? finalVisibleSlides : finalSlides.length < 4 ? finalSlides.length : 4;
    visibleSlides = parseInt(visibleSlides, 10);
    if (parseInt(visibleSlides, 10) === 4) {
      imageHeight = 335;
    }
  }
  if (isMobileTabletOrSmallDesktop) {
    imageWidth = 320;
    imageHeight = 320;
    visibleSlides = finalSlides.length < 3 ? finalSlides.length : 3;
  }
  if (isMobile) {
    imageWidth = 720;
    imageHeight = 720;
    visibleSlides = 2;
  }
  if (!finalSlides.length) {
    return null;
  }
  if (finalSlides && finalSlides.length === 1) {
    return <div className="mt-5 [&_.slider]:min-h-[1px] [&_.slider]:m-auto [&_.slider-slide>img]:object-cover [&_img]:w-auto [&_img]:max-h-[450px] [&_img]:object-contain" ref={containerRef}><CDNImageManager key="1" src={finalSlides[0].src || finalSlides[0].url || finalSlides[0].val} trim="auto" lazy={true} sizes="100vw" /></div>;
  }
  if (finalSlides.length < 8 && finalSlides.length > visibleSlides) {
    while (finalSlides.length < 8) {
      finalSlides = finalSlides.concat(finalSlides);
    }
  }
  const hideNav = visibleSlides >= finalSlides.length;
  const t4 = "mt-5 [&_.slider]:min-h-[1px] [&_.slider]:m-auto [&_.slider-slide>img]:object-cover [&_.slider-control-bottomcenter]:w-full";
  const t5 = isMobile ? <MobileSlider slides={finalSlides} imageWidth={imageWidth} imageHeight={imageHeight} sizes={null} /> : <NukaCarousel slideIndex={slideIndex || 0} slidesToShow={visibleSlides} cellSpacing={20} dragging={true} wrapAround={finalSlides.length > visibleSlides} width="100%" speed={200} renderCenterLeftControls={t6 => {
    const {
      previousSlide
    } = t6;
    return <button className={classNames("group/SliderButton w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white left-2 transform-[translateX(-50%)]", "[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray", "group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]", {
      "!hidden": hideArrowsIfAllSlidesVisible && finalSlides.length <= 3,
      "xl:!hidden": hideArrowsIfAllSlidesVisible && finalSlides.length === 4
    })} aria-label="Previous slide" onClick={previousSlide} type="button">{" "}<IconArrowLeftWhite /></button>;
  }} renderCenterRightControls={t7 => {
    const {
      nextSlide
    } = t7;
    return <button className={classNames("group/SliderButton w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white right-2 transform-[translateX(50%)]", "[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray", "group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]", {
      "!hidden": hideArrowsIfAllSlidesVisible && finalSlides.length <= 3,
      "xl:!hidden": hideArrowsIfAllSlidesVisible && finalSlides.length === 4
    })} aria-label="Next slide" onClick={nextSlide} type="button"><IconArrowRightWhite /></button>;
  }} renderBottomCenterControls={controlProps => {
    if (navType === "Button" || hideNav) {
      return null;
    }
    const slideCountArray = [...Array(controlProps.slideCount).keys()];
    return <div className={classNames("absolute block bottom-[-45px] w-full p-0 m-0 list-none text-center", "[&_button]:border-0 [&_button]:rounded-[50%] [&_button]:h-2 [&_button]:!w-2 [&_button]:bg-[#0eb9cb] [&_button]:!m-1 [&_button]:relative [&_button]:inline-block", "[&_button:disabled]:bg-gray-light5", "[&_button_span]:inline-block [&_button_span]:h-5 [&_button_span]:w-full [&_button_span]:max-w-[30px]")}>{slideCountArray.map((slide, index) => <button key={slide?.src ?? index} aria-label={`Go to slide ${index + 1}`} disabled={controlProps.currentSlide === index} onClick={() => controlProps.goToSlide(index)} type="button"><span /></button>)}</div>;
  }} afterSlide={slideCount => {
    updateAfterSlider(slideCount);
  }} beforeSlide={slideCount_0 => {
    updateBeforeSlider(slideCount_0);
  }} heightMode="first" initialSlideWidth={imageWidth}>{finalSlides.map(image => <CDNImageManager key={image.value || image.src || image.url} src={image.value || image.src || image.url} width={imageWidth} height={imageHeight} trim="auto" sizes={null} lazy={true} alt="" />)}</NukaCarousel>;
  let t8;
  if ($[1] !== t5) {
    t8 = <div className={t4} ref={containerRef}>{t5}</div>;
    $[1] = t5;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  return t8;
};
SliderStandard.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    url: PropTypes.string,
    value: PropTypes.string
  })),
  finalVisibleSlides: PropTypes.number,
  hideArrowsIfAllSlidesVisible: PropTypes.bool,
  imageArray: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    url: PropTypes.string,
    value: PropTypes.string
  })),
  imageHeight: PropTypes.string,
  imageWidth: PropTypes.string,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  updateImageArraySize: PropTypes.func
};
export default SliderStandard;